import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";
import MenuStore from "@/store/modules/MenuStore";
import OptionsModule from "@/store/modules/OptionsModule";
import GeoModule from "@/store/modules/GeoModule";

config.rawError = true;

const store = createStore({
  modules: {
    AuthModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    MenuStore,
    OptionsModule,
    GeoModule,
  },
});

export default store;
